import SignatureKeyStepper from 'components/SignatureKey/SignatureKeyStepper';
import { SIGNATURE_KEY_ENABLED } from 'constants/featureFlagging';
import { SIGNATURE_KEY_VIEW } from 'constants/steps';

export const generateSignatureKeyStep = ({ key, previousStep }) => ({
    key,
    previousStep,
    icon: 'pen',
    active: false,
    title: SIGNATURE_KEY_VIEW,
    stepName: SIGNATURE_KEY_VIEW,
    component: SignatureKeyStepper,
    flagControl: SIGNATURE_KEY_ENABLED,
});
